export default "__VITE_ASSET__8dd7178c__"